import { apiClient } from '@/lib/api'

const COMPLEXES_BASE = '/v1/estates/live-complexes'

/**
 * Live Complexes API (Superadmin only)
 * CRUD operations for residential complexes
 */

// Get all complexes with filters
export const getComplexes = async (params = {}) => {
  const response = await apiClient.get(`${COMPLEXES_BASE}/`, { params })
  return response
}

// Get complex by ID
export const getComplex = async (id) => {
  const response = await apiClient.get(`${COMPLEXES_BASE}/${id}/`)
  return response
}

// Create new complex
export const createComplex = async (data) => {
  const response = await apiClient.post(`${COMPLEXES_BASE}/`, data)
  return response
}

// Update complex (PUT - full update)
export const updateComplex = async (id, data) => {
  const response = await apiClient.put(`${COMPLEXES_BASE}/${id}/`, data)
  return response
}

// Partial update complex (PATCH)
export const patchComplex = async (id, data) => {
  const response = await apiClient.patch(`${COMPLEXES_BASE}/${id}/`, data)
  return response
}

// Delete complex
export const deleteComplex = async (id) => {
  const response = await apiClient.delete(`${COMPLEXES_BASE}/${id}/`)
  return response
}
